import React, { useState, useEffect } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from './ui/card';

interface CareSymbol {
  id: string;
  url: string;
  label: string;
  shortLabel: string; // Grid'de gösterilecek kısa versiyon
  category: string;
}

interface FabricCareSelectorProps {
  value: string; // HTML string
  onChange: (html: string) => void;
}

const CARE_SYMBOLS: CareSymbol[] = [
  // Yıkama
  { id: 'wash_95', url: 'https://clothing.beautyomelette.com/uploads/editoruploads/talimatlar/lavage_95_normal.svg', label: '95°C\'DE MAKSİMUM YIKAMA YAPINIZ.', shortLabel: '95°C Yıkama', category: 'Yıkama' },
  { id: 'wash_70', url: 'https://clothing.beautyomelette.com/uploads/editoruploads/talimatlar/lavage_70_normal.svg', label: '70°C\'DE MAKSİMUM YIKAMA YAPINIZ.', shortLabel: '70°C Yıkama', category: 'Yıkama' },
  { id: 'wash_60', url: 'https://clothing.beautyomelette.com/uploads/editoruploads/talimatlar/lavage_60_normal.svg', label: '60°C\'DE MAKSİMUM YIKAMA YAPINIZ.', shortLabel: '60°C Yıkama', category: 'Yıkama' },
  { id: 'wash_60_mod', url: 'https://clothing.beautyomelette.com/uploads/editoruploads/talimatlar/lavage_60_modere.svg', label: '60°C\'DE ORTA PROGRAMDA YIKAMA YAPINIZ.', shortLabel: '60°C Orta', category: 'Yıkama' },
  { id: 'wash_40', url: 'https://clothing.beautyomelette.com/uploads/editoruploads/talimatlar/lavage_40_normal.svg', label: '40°C\'DE MAKSİMUM YIKAMA YAPINIZ.', shortLabel: '40°C Yıkama', category: 'Yıkama' },
  { id: 'wash_40_mod', url: 'https://clothing.beautyomelette.com/uploads/editoruploads/talimatlar/lavage_40_modere.svg', label: '40°C\'DE ORTA PROGRAMDA YIKAMA YAPINIZ.', shortLabel: '40°C Orta', category: 'Yıkama' },
  { id: 'wash_40_gentle', url: 'https://clothing.beautyomelette.com/uploads/editoruploads/talimatlar/lavage_40_tres_modere.svg', label: '40°C\'DE HASSAS PROGRAMDA YIKAMA YAPINIZ.', shortLabel: '40°C Hassas', category: 'Yıkama' },
  { id: 'wash_30', url: 'https://clothing.beautyomelette.com/uploads/editoruploads/talimatlar/lavage_30_normal.svg', label: '30°C\'DE MAKSİMUM YIKAMA YAPINIZ.', shortLabel: '30°C Yıkama', category: 'Yıkama' },
  { id: 'wash_30_mod', url: 'https://clothing.beautyomelette.com/uploads/editoruploads/talimatlar/lavage_30_modere.svg', label: '30°C\'DE ORTA PROGRAMDA YIKAMA YAPINIZ.', shortLabel: '30°C Orta', category: 'Yıkama' },
  { id: 'wash_30_gentle', url: 'https://clothing.beautyomelette.com/uploads/editoruploads/talimatlar/lavage_30_tres-modere.svg', label: '30°C\'DE HASSAS PROGRAMDA YIKAMA YAPINIZ.', shortLabel: '30°C Hassas', category: 'Yıkama' },
  { id: 'wash_hand', url: 'https://clothing.beautyomelette.com/uploads/editoruploads/talimatlar/lavage_main.svg', label: 'EL İLE YIKAMA YAPINIZ.', shortLabel: 'El Yıkama', category: 'Yıkama' },
  { id: 'wash_forbidden', url: 'https://clothing.beautyomelette.com/uploads/editoruploads/talimatlar/lavage_interdit.svg', label: 'YIKAMA YAPMAYINIZ.', shortLabel: 'Yıkama Yasak', category: 'Yıkama' },
  
  // Ağartma
  { id: 'bleach_ok', url: 'https://clothing.beautyomelette.com/uploads/editoruploads/talimatlar/blanchiment_autorise.svg', label: 'AĞARTICI KULLANILABİLİR.', shortLabel: 'Ağartma OK', category: 'Ağartma' },
  { id: 'bleach_oxygen', url: 'https://clothing.beautyomelette.com/uploads/editoruploads/talimatlar/blanchiment_oxygene.svg', label: 'OKSİJEN BAZLI AĞARTICI KULLANILABİLİR.', shortLabel: 'Oksijen Ağartma', category: 'Ağartma' },
  { id: 'bleach_forbidden', url: 'https://clothing.beautyomelette.com/uploads/editoruploads/talimatlar/blanchiment_interdit.svg', label: 'AĞARTICI KULLANMAYINIZ.', shortLabel: 'Ağartma Yasak', category: 'Ağartma' },
  
  // Kurutma
  { id: 'dry_normal', url: 'https://clothing.beautyomelette.com/uploads/editoruploads/talimatlar/sechage_tambour_normal.jpg', label: 'TAMBURLU KURUTMA YAPILABİLİR.', shortLabel: 'Tambur OK', category: 'Kurutma' },
  { id: 'dry_moderate', url: 'https://clothing.beautyomelette.com/uploads/editoruploads/talimatlar/sechage_tambour_modere.svg', label: 'DÜŞÜK ISIDA TAMBURLU KURUTMA YAPILABİLİR.', shortLabel: 'Düşük Tambur', category: 'Kurutma' },
  { id: 'dry_forbidden', url: 'https://clothing.beautyomelette.com/uploads/editoruploads/talimatlar/sechage_tambour_interdit.svg', label: 'TAMBURLU KURUTMA YAPMAYINIZ.', shortLabel: 'Tambur Yasak', category: 'Kurutma' },
  { id: 'dry_line', url: 'https://clothing.beautyomelette.com/uploads/editoruploads/talimatlar/sechage_fil.svg', label: 'İPTE KURUTMA YAPINIZ.', shortLabel: 'İpte Kurutma', category: 'Kurutma' },
  { id: 'dry_line_no_spin', url: 'https://clothing.beautyomelette.com/uploads/editoruploads/talimatlar/sechage_fil_sans_essorage.svg', label: 'SIKMA YAPMADAN İPTE KURUTUNUZ.', shortLabel: 'İpte (Sıkmasız)', category: 'Kurutma' },
  { id: 'dry_flat', url: 'https://clothing.beautyomelette.com/uploads/editoruploads/talimatlar/sechage_plat.svg', label: 'DÜZ OLARAK KURUTUNUZ.', shortLabel: 'Düz Kurutma', category: 'Kurutma' },
  { id: 'dry_flat_no_spin', url: 'https://clothing.beautyomelette.com/uploads/editoruploads/talimatlar/sechage_plat_sans_essorage.svg', label: 'SIKMA YAPMADAN DÜZ KURUTUNUZ.', shortLabel: 'Düz (Sıkmasız)', category: 'Kurutma' },
  { id: 'dry_shade', url: 'https://clothing.beautyomelette.com/uploads/editoruploads/talimatlar/sechage_fil_ombre.svg', label: 'GÖLGEDE İPTE KURUTUNUZ.', shortLabel: 'Gölgede', category: 'Kurutma' },
  
  // Ütüleme
  { id: 'iron_200', url: 'https://clothing.beautyomelette.com/uploads/editoruploads/talimatlar/repassage_max_200.svg', label: '200°C DERECEDE ÜTÜLEME.', shortLabel: '200°C Ütü', category: 'Ütüleme' },
  { id: 'iron_150', url: 'https://clothing.beautyomelette.com/uploads/editoruploads/talimatlar/repassage_max_150.svg', label: '150°C DERECEDE ÜTÜLEME.', shortLabel: '150°C Ütü', category: 'Ütüleme' },
  { id: 'iron_110', url: 'https://clothing.beautyomelette.com/uploads/editoruploads/talimatlar/repassage_max_110.svg', label: '110°C DERECEDE ÜTÜLEME.', shortLabel: '110°C Ütü', category: 'Ütüleme' },
  { id: 'iron_no_steam', url: 'https://clothing.beautyomelette.com/uploads/editoruploads/talimatlar/gin_do-not-steam-black.png', label: 'BUHARLI ÜTÜLEME YAPMAYINIZ.', shortLabel: 'Buhar Yasak', category: 'Ütüleme' },
  { id: 'iron_forbidden', url: 'https://clothing.beautyomelette.com/uploads/editoruploads/talimatlar/repassage_interdit.svg', label: 'ÜTÜLEME YAPMAYINIZ.', shortLabel: 'Ütü Yasak', category: 'Ütüleme' },
  
  // Kuru Temizleme
  { id: 'clean_p_normal', url: 'https://clothing.beautyomelette.com/uploads/editoruploads/talimatlar/nettoyage_prof_sec_p_normal.svg', label: 'KURU TEMİZLEME YAPINIZ.', shortLabel: 'Kuru Temizleme', category: 'Kuru Temizleme' },
  { id: 'clean_p_moderate', url: 'https://clothing.beautyomelette.com/uploads/editoruploads/talimatlar/nettoyage_prof_sec_p_modere.svg', label: 'HASSAS KURU TEMİZLEME YAPINIZ.', shortLabel: 'Hassas Kuru', category: 'Kuru Temizleme' },
  { id: 'clean_f_normal', url: 'https://clothing.beautyomelette.com/uploads/editoruploads/talimatlar/nettoyage_prof.-sec_f_normal.jpg', label: 'KURU TEMİZLEME YAPINIZ.', shortLabel: 'Kuru (F)', category: 'Kuru Temizleme' },
  { id: 'clean_forbidden', url: 'https://clothing.beautyomelette.com/uploads/editoruploads/talimatlar/nettoyage_prof._sec_interdit.svg', label: 'KURU TEMİZLEME YAPMAYINIZ.', shortLabel: 'Kuru Yasak', category: 'Kuru Temizleme' },
  { id: 'clean_w_normal', url: 'https://clothing.beautyomelette.com/uploads/editoruploads/talimatlar/nettoyage_prof.eau_w_normal.svg', label: 'ISLAK TEMİZLEME YAPILABİLİR.', shortLabel: 'Islak OK', category: 'Kuru Temizleme' },
  { id: 'clean_w_moderate', url: 'https://clothing.beautyomelette.com/uploads/editoruploads/talimatlar/nettoyage_prof_eau_w_modere.svg', label: 'HASSAS ISLAK TEMİZLEME YAPILABİLİR.', shortLabel: 'Hassas Islak', category: 'Kuru Temizleme' },
  { id: 'clean_w_gentle', url: 'https://clothing.beautyomelette.com/uploads/editoruploads/talimatlar/nettoyage_prof_eau_w_tres_modere.svg', label: 'ÇOK HASSAS ISLAK TEMİZLEME YAPILABİLİR.', shortLabel: 'Çok Hassas Islak', category: 'Kuru Temizleme' },
  { id: 'clean_w_forbidden', url: 'https://clothing.beautyomelette.com/uploads/editoruploads/talimatlar/nettoyage_prof.eau_w_interdit.svg', label: 'ISLAK TEMİZLEME YAPMAYINIZ.', shortLabel: 'Islak Yasak', category: 'Kuru Temizleme' },
];

const FabricCareSelector: React.FC<FabricCareSelectorProps> = ({ 
  value, 
  onChange
}) => {
  const [selectedSymbols, setSelectedSymbols] = useState<string[]>([]);
  const [selectedCategory, setSelectedCategory] = useState<string>('Yıkama');

  const categories = ['Yıkama', 'Ağartma', 'Kurutma', 'Ütüleme', 'Kuru Temizleme'];

  // HTML'den sembolleri çıkar
  useEffect(() => {
    if (value) {
      const selectedIds: string[] = [];
      CARE_SYMBOLS.forEach(symbol => {
        if (value.includes(symbol.url)) {
          selectedIds.push(symbol.id);
        }
      });
      setSelectedSymbols(selectedIds);
    }
  }, [value]);

  // 🎯 KAYDET BUTONUNA BASILINCA ÇALIŞMASI İÇİN
  // Local state her değiştiğinde HTML'i güncelle ve parent'a gönder
  // Ama Ticimax'a gönderim sadece form submit'te yapılacak
  useEffect(() => {
    const html = generateHTML(selectedSymbols);
    onChange(html);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedSymbols]);

  // HTML oluştur
  const generateHTML = (symbols: string[]) => {
    if (symbols.length === 0) return '';

    const selectedSymbolsData = CARE_SYMBOLS.filter(s => symbols.includes(s.id));
    
    let html = '<!-- Bakım Bilgileri -->\n';
    html += '<div style="font-family: Arial, sans-serif; max-width: 600px;">\n';
    html += '  <!-- Bakım Talimatları -->\n';
    html += '  <div style="font-size: 13px; line-height: 2;">\n';
    
    selectedSymbolsData.forEach(symbol => {
      html += '    <p style="margin: 8px 0; display: flex; align-items: center; gap: 8px;">\n';
      html += `      <img src="${symbol.url}" alt="${symbol.label}" style="width: 22px; height: 22px; flex-shrink: 0;">\n`;
      html += `      <strong>${symbol.label}</strong>\n`;
      html += '    </p>\n';
    });
    
    html += '  </div>\n';
    html += '</div>';
    
    return html;
  };

  const handleSymbolToggle = (symbolId: string) => {
    const newSelected = selectedSymbols.includes(symbolId)
      ? selectedSymbols.filter(id => id !== symbolId)
      : [...selectedSymbols, symbolId];
    
    // SADECE LOCAL STATE GÜNCELLENİYOR - TİCİMAX'A GÖNDERİM YOK
    setSelectedSymbols(newSelected);
    // onChange artık burada çağrılmıyor - sadece kaydet butonunda çağrılacak
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-sm">Bakım Bilgileri</CardTitle>
        <p className="text-xs text-muted-foreground mt-1">
          Seçtiğiniz bakım sembolleri kaydederken otomatik olarak açıklamaya eklenecektir.
        </p>
      </CardHeader>
      <CardContent className="space-y-4">
        {/* Kategori Seçimi */}
        <div>
          <label className="block text-xs font-medium mb-2">
            Bakım Sembolü Seç
            {selectedSymbols.length > 0 && (
              <span className="ml-2 text-primary">({selectedSymbols.length} sembol seçildi)</span>
            )}
          </label>
          <div className="flex gap-2 mb-3 overflow-x-auto pb-2">
            {categories.map(cat => (
              <button
                key={cat}
                type="button"
                onClick={(e) => {
                  e.preventDefault();
                  setSelectedCategory(cat);
                }}
                className={`px-3 py-1 text-xs font-medium rounded-full whitespace-nowrap transition-colors ${
                  selectedCategory === cat
                    ? 'bg-primary text-primary-foreground'
                    : 'bg-gray-100 hover:bg-gray-200'
                }`}
              >
                {cat}
              </button>
            ))}
          </div>
        </div>

        {/* Sembol Grid */}
        <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-5 gap-2 max-h-64 overflow-y-auto p-2 border border-gray-200 rounded-md">
          {CARE_SYMBOLS.filter(s => s.category === selectedCategory).map(symbol => (
            <button
              key={symbol.id}
              type="button"
              onClick={(e) => {
                e.preventDefault();
                handleSymbolToggle(symbol.id);
              }}
              className={`p-2 border-2 rounded-lg transition-all hover:shadow-md flex flex-col items-center gap-1 ${
                selectedSymbols.includes(symbol.id)
                  ? 'border-primary bg-primary/5'
                  : 'border-gray-200 hover:border-gray-300'
              }`}
              title={symbol.label}
            >
              <img
                src={symbol.url}
                alt={symbol.label}
                className="w-10 h-10 object-contain"
              />
              <span className="text-[10px] text-center leading-tight">{symbol.shortLabel}</span>
            </button>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default FabricCareSelector;

